export const CATEGORY_LIST_URL =
    "https://raw.githubusercontent.com/thanakijwanavit/villaMasterSchema/master/webData/firstPageCat.yaml";
